
import React, { Component } from 'react';
import {Link} from 'react-router-dom';

//Other Helpers
import BlurImageLoader from 'react-blur-image-loader'

class KeyMakersBanner extends React.Component {
	render() {
		return ( 
            <section className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="featued-container key-maker">
                            <div className="row">
                                <div className="col-sm-6 col-sm-offset-6">
                                    <div className="featured-wrapper">
                                        <h3>Mangler du ekstra nøgler til din cykel eller almidelige låse?</h3>
                                        <p>En ekstranøgle er altid god ide at have i reserve. Vi fremstiller gerne duplikatsæt af alle dine nøgler.</p>
                                        <p>Det er enkelt og hurtigt at bestille nøgler. Ønsker du at bestille ekstra nøgler er der mulighed for det, vi kan tilbyde en god og hurtig service, alt i alt mens du venter eller foretager dine andre indkøb.</p>
                                        <p>Vi er placeret I husum torvet kom forbi, og oplev en forskel. </p>
                                        <Link to="/contact" className="btn btn-default btn-lg">Kontakt Os</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
	}
}

export default KeyMakersBanner;


// WEBPACK FOOTER //
// ./src/Components/KeyMakersBanner.js